export const USERNAME_MIN_LENGTH = 6;
export const USERNAME_MAX_LENGTH = 12;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;
export const BONUS_CODE_MAX_LENGTH = 15;
export const FIRST_NAME_MAX_LENGTH = 40;
export const LAST_NAME_MAX_LENGTH = 40;
export const POST_CODE_MIN_LENGTH = 3;
export const POST_CODE_MAX_LENGTH = 10;
export const CITY_MIN_LENGTH = 3;
export const CITY_MAX_LENGTH = 100;
export const ANSWER_MAX_LENGTH = 30;
export const ADDRESS_1_MAX_LENGTH = 30;
export const ADDRESS_2_MAX_LENGTH = 30;
